<template>
  <div class="page_box">
    <div class="page_table_box" style="height:calc(100% - 10px)">
      <div class="school_table_box" style="height:100%;overflow-y: scroll;">
        <el-form
          :model="formData"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="ruleForm"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="上班时间点:" prop="startTime">
                <template>
                  <el-time-picker
                    placeholder="上班时间点"
                    v-model="formData.startTime"
                    size="small"
                    value-format="HH:mm:ss"
                  >
                  </el-time-picker>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="下班时间点:" prop="endTime">
                <template>
                  <el-time-picker
                    placeholder="下班时间点"
                    v-model="formData.endTime"
                    size="small"
                    value-format="HH:mm:ss"
                  >
                  </el-time-picker>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度:">
                <template>
                  <span>{{ formData.coordinate.split(',')[0] }}</span>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纬度:">
                <template>
                  <span>{{ formData.coordinate.split(',')[1] }}</span>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="坐标名:">
                <template>
                  <span>{{ formData.coordinateName }}</span>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="打卡范围:" prop="coordinateScope">
                <template>
                  <el-input
                    size="small"
                    v-model="formData.coordinateScope"
                    placeholder="请输入打卡范围"
                  >
                    <template slot="append">m</template>
                  </el-input>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
            <baidu-map
              ref="map"
              v-if="center.lng != 0"
              class="map"
              @ready="handler"
              :center="center"
              :zoom="20"
              :scroll-wheel-zoom="true"
              :double-click-zoom="false"
              :mapClick="false"
              @click="sel"
            >
              <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
              <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
              <bm-marker
                :position="position"
                :dragging="false"
                animation="BMAP_ANIMATION_BOUNCE"
                :icon="{
                  url: require('@/assets/img/edu/marker_sprite.png'),
                  size: { width: 20, height: 40 }
                }"
              >
                <bm-circle
                  :center="circlePath.center"
                  :radius="circlePath.radius"
                  stroke-color="CAD5EB"
                  :stroke-opacity="0.5"
                  :stroke-weight="0.1"
                  fillColor="#CAD5EB"
                  :fillOpacity="0.5"
                ></bm-circle>
              </bm-marker>
            </baidu-map>
          <div class="save-box">
            <el-button
              type="primary"
              size="small"
              @click="sendEduData('ruleForm')"
              v-loading="loading"
              >提交保存</el-button
            >
          </div>
      </div>
    </div>
  </div>
</template>
<script>
// import BaiduMap from "vue-baidu-map/components/map/Map.vue";
export default {
  name: "AttendanceRule",
  components: {},
  data() {
    var num = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
    var checkNum = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!num.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      formData: {
        startTime: "", //上班时间点，
        endTime: "", //下班时间点
        coordinate: "113.665412,34.757975", // 默认设为郑州市经纬度
        coordinateName: "郑州市",
        coordinateScope: 50 // 打开范围
      },
      rules: {
        startTime: [{ required: true, message: " ", trigger: "change" }],
        endTime: [{ required: true, message: " ", trigger: "change" }],
        coordinate: [{ required: true, message: " ", trigger: "change" }],
        coordinateScope: [
          { required: true, validator: checkNum, trigger: "blur" }
        ]
      },
      // 百度地图
      center: {
        lng: 0,
        lat: 0
      },
      position: {},
      circlePath: {
        center: {
          lng: 0,
          lat: 0
        },
        radius: 100
      },

      loading: false
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    "formData.coordinateScope": function(newVal) {
      this.circlePath.radius = newVal;
    }
  },
  methods: {
    async getList() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getAttendanceRule(req);
      if (res.code == 200) {
        this.formData = res.data;

        this.getPosition();
      } else if (res.code == 101) {
        this.getPosition();
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    handler: function({ BMap, map }) {
      this.BMap = BMap;
      this.map = map;
    },
    getPosition() {
      let latAndLnt = this.formData.coordinate.split(",");
      this.center.lat = latAndLnt[1];
      this.center.lng = latAndLnt[0];
      // console.log(this.center);
      this.position = this.center;
      this.circlePath.center = this.center;
      this.circlePath.radius = this.formData.coordinateScope;
    },
    sel({ type, target, point, pixel, overlay }) {
      // console.log(point)
      this.position = point;
      this.circlePath.center = point;
      this.formData.coordinate = point.lng + "," + point.lat;
      // console.log(this.formData.coordinate)

      // 根据坐标获取地址名字
      const gc = new this.BMap.Geocoder();
      gc.getLocation(point, (res) => {
        // console.log(res)
        this.formData.coordinateName = res.address;
      });
    },

    // 定位提交按钮
    sendEduData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.formData.schoolId = this.$store.state.schoolId;
          this.saveData();
        } else {
          // console.log('error submit!!')
          return false;
        }
      });
    },
    async saveData() {
      let req = Object.assign({}, this.formData);
      let res = await this.$Http.addOrEditAttendanceRule(req, true);
      this.loading = false;
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "提交成功"
        });
        this.getList();
      } else if (res.code == 101) {
        this.$message({
          type: "warning",
          message: res.messsage || "提交失败"
        });
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "提交失败"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.ruleForm {
  margin: 0px 20px;
  height: 160px;
}
.map {
  margin-left: 20px;
  width: calc(100% - 40px);
  height: calc(100% - 220px);
  min-height: 500px;
  
}
.save-box{
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: flex-end;
  margin-right: 40px;
  align-items: center;
}
</style>
